#import "../fragments/peep-related-lead-stats-fragment.graphql"

query GetPeepRelatedLeadStats($id: ID!) {
    peep(id: $id) {
        ...PeepRelatedLeadStats
    }
}
